/* gallery-look.js  "Add all to bag" for the Complete the Look section.
   Adds every available look piece to the cart, then sends the shopper to the cart.
   Each piece is added with its OWN /cart/add.js call and individual failures are
   tolerated — a single bulk `items:[]` call is atomic, so one sold-out piece would
   otherwise make the whole "add all" silently do nothing. Scoped to
   [data-gly-look-add]; never touches the theme's own product/cart JS. */
(function () {
  'use strict';

  function collectItems(section) {
    var counts = {}; // variantId -> quantity (dedupes if a piece repeats)
    var cards = section.querySelectorAll('[data-look-card]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-available') !== 'true') continue;
      var id = card.getAttribute('data-variant');
      if (!id) continue;
      counts[id] = (counts[id] || 0) + 1;
    }
    return Object.keys(counts).map(function (id) {
      return { id: Number(id), quantity: counts[id] };
    });
  }

  function addAll(btn) {
    var section = btn.closest('[data-section-type="gly-look"]');
    if (!section) return;
    var items = collectItems(section);
    if (!items.length) return;

    var textEl = btn.querySelector('[data-look-add-text]');
    var addedLabel = btn.getAttribute('data-added-label') || 'Added';
    btn.disabled = true;
    if (textEl) textEl.textContent = 'Adding…';

    // Add each piece on its own so one unavailable item can't sink the whole batch.
    Promise.all(items.map(function (it) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: it.id, quantity: it.quantity })
      }).then(function (res) { return res.ok; }).catch(function () { return false; });
    })).then(function (results) {
      var added = results.filter(Boolean).length;
      if (added > 0) {
        if (textEl) textEl.textContent = addedLabel;
        window.setTimeout(function () { window.location.href = '/cart'; }, 500);
      } else {
        btn.disabled = false;
        if (textEl) textEl.textContent = 'Sold out';
        window.setTimeout(function () {
          if (textEl) textEl.textContent = btn.getAttribute('data-original-label') || 'Add all to bag';
        }, 2500);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gly-look-add]');
    if (!btn) return;
    e.preventDefault();
    var textEl = btn.querySelector('[data-look-add-text]');
    if (textEl && !btn.getAttribute('data-original-label')) {
      btn.setAttribute('data-original-label', textEl.textContent);
    }
    addAll(btn);
  });
})();
